// The customer-facing shipping rules, in one place.
//
// These mirror the defaults in the shinyvault-checkout edge function
// (SIGNATURE_THRESHOLD_CENTS, INSURANCE_MIN_CENTS, INSURANCE_RATE). The function
// is the authority — it decides what actually gets bought. This file only exists
// so the checkout page and the shipping page can state the same rules out loud
// instead of each hardcoding a number in prose. If a threshold changes there,
// change it here too.

// Local pickup is paused. Trainer Center packs and ships on Tuesdays and
// Fridays, and a pickup lane on top of that was more than the counter could
// carry right now (Chase, 09.15.2026). Flip this back to true to bring it back;
// the pickup code paths are all still here. The edge function has its own
// switch, SHINYVAULT_PICKUP_ENABLED, because a client flag protects nothing.
export const PICKUP_ENABLED = false;

// What a customer is promised, in their words rather than ours. The packing
// days themselves are staff business and are deliberately not published.
export const SHIP_WINDOW = 'We ship within 24 to 72 hours';

export const INSURANCE_MIN_CENTS = 10000;      // insure above $100
export const INSURANCE_RATE = 0.0125;          // 1.25% of declared value
export const SIGNATURE_THRESHOLD_CENTS = 25000; // signature above $250

export const usd = (cents) => `$${(cents / 100).toFixed(cents % 100 ? 2 : 0)}`;

export const insuranceLine =
  `Orders over ${usd(INSURANCE_MIN_CENTS)} are insured for their full value at ` +
  `${(INSURANCE_RATE * 100).toFixed(2).replace(/0$/, '')}% of the order total, included in the shipping price.`;

export const signatureLine =
  `Orders over ${usd(SIGNATURE_THRESHOLD_CENTS)} ship with signature confirmation, ` +
  `so someone has to be there to sign.`;
